export const variables = {
  ecommerce_admin: 'ecommerce_warehouse',
  DISCOUNT_ACTIVE_STATUS_ID: 35,
  DISCOUNT_ACTIVE_IN_STATUS_ID: 36,
  DISCOUNT_ACTIVE_STATUS: 'Active',
  DISCOUNT_INACTIVE_STATUS: 'In active',

  ACTIVE_STATUS_ID: 1,
  INACTIVE_STATUS_ID: 2,
  SUSPEND_STATUS_ID: 3,
  ACTIVE_STATUS: 'Active',
  INACTIVE_STATUS: 'In Active',
  SUSPEND_STATUS: 'Suspend',

  UNKNOWN_USER_STATUS_ID: 1,
  UNKNOWN_USER_STATUS: 'Unknown',

  GUEST_USER_STATUS_ID: 2,
  GUEST_USER_STATUS: 'Guest',

  INVITED_USER_STATUS_ID: 3,
  INVITED_USER_STATUS: 'Invited',

  MEMBER_USER_STATUS_ID: 4,
  MEMBER_USER_STATUS: 'Member',

  MEMBERSHIP_EXPIRED_USER_STATUS_ID: 5,
  MEMBERSHIP_EXPIRED_USER_STATUS: 'Membership Expired',

  WAREHOUSE_USERNAME: 'ware_username',

  PRODUCT_ACTIVE_STATUS: 'Active',
  PRODUCT_INACTIVE_STATUS: 'Inactive',
  PRODUCT_ACTIVE_STATUS_ID: 9,
  PRODUCT_INACTIVE_STATUS_ID: 10,

  CATEGORY_ACTIVE_STATUS: 'Active',
  CATEGORY_INACTIVE_STATUS: 'In Active',
  CATEGORY_ACTIVE_STATUS_ID: 3,
  CATEGORY_INACTIVE_STATUS_ID: 4,

  CLUB_ACTIVE_STATUS_ID: 1,
  CLUB_INACTIVE_STATUS_ID: 2,
  CLUB_ACTIVE_STATUS: 'Active',
  CLUB_INACTIVE_STATUS: 'In Active',

  EVENT_ACTIVE_STATUS_ID: 1,
  EVENT_INACTIVE_STATUS_ID: 2,
  EVENT_ACTIVE_STATUS: 'Active',
  EVENT_INACTIVE_STATUS: 'In Active',

  FESTIVAL_ACTIVE_STATUS_ID: 1,
  FESTIVAL_INACTIVE_STATUS_ID: 2,
  FESTIVAL_ACTIVE_STATUS: 'Active',
  FESTIVAL_INACTIVE_STATUS: 'In Active',

  AFTER_PARTY_ACTIVE_STATUS_ID: 1,
  AFTER_PARTY_INACTIVE_STATUS_ID: 2,
  AFTER_PARTY_ACTIVE_STATUS: 'Active',
  AFTER_PARTY_INACTIVE_STATUS: 'In Active',

  REQUEST_APPROVED_STATUS_ID: 1,
  REQUEST_REJECTED_STATUS_ID: 2,
  REQUEST_PENDING_STATUS_ID: 3,
  REQUEST_APPROVED_STATUS: 'Approved',
  REQUEST_REJECTED_STATUS: 'Rejected',
  REQUEST_PENDING_STATUS: 'Pending',

  GIFT_ACTIVE_STATUS: 'true',
  GIFT_INACTIVE_STATUS: 'false',
  GIFT_ACTIVE_STATUS_ID: 23,
  GIFT_INACTIVE_STATUS_ID: 24,

  OPTION_ACTIVE_STATUS: 'Active',
  OPTION_APPROVE_STATUS: 'Approve',
  OPTION_ACTIVE_STATUS_ID: 5,
  OPTION_APPROVE_STATUS_ID: 3,

  COUPON_ACTIVE_STATUS: 'Active',
  COUPON_INACTIVE_STATUS: 'In active',
  COUPON_ACTIVE_STATUS_ID: 28,

  DELIVERY_PENDING_STATUS: 'Pending',
  DELIVERY_ACCEPTED_STATUS: 'Accepted',
  DELIVERY_PENDING_STATUS_ID: 17,
  DELIVERY_ACCEPTED_STATUS_ID: 18,

  RESTAURANT_ACTIVE_STATUS_ID: 1,
  RESTAURANT_INACTIVE_STATUS_ID: 2,
  RESTAURANT_ACTIVE_STATUS: 'Yes',
  RESTAURANT_INACTIVE_STATUS: 'No',
};

export const IS_REQUEST = [
  {id: 1, title: 'Received'},
  {id: 2, title: 'Confirm'},
  {id: 3, title: 'Request for reject'},
  {id: 4, title: 'Cancelled'},
];

export const GUEST_STATUS = [
  {id: 1, title: 'New'},
  {id: 2, title: 'Confirm'},
  {id: 3, title: 'Removed'},
  {id: 4, title: 'Cancelled'},
];

// export const REQUEST_BY_USER = [
//   {id: 1, title: 'Approved'},
//   {id: 2, title: 'Reject'},
//   {id: 3, title: 'Pending'},
// ];

export const regex = {
  passwordRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/,
};

export const productTabKeys = {
  DATA: 'data',
  OPTIONS: 'options',
};

export const AGREEMENT_STATUS = [
  {id: 1, name: 'Partner'},
  {id: 2, name: 'Not Partner'},
  {id: 3, name: 'Pending'},
];
